import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Do I need a specific degree to work in HR?t",
    category: "Technology",
    description:
      "A degree in HR, business, psychology, or management helps, but many HR roles can be learned through certification programs. Strong communication, people skills, and organizational abilities are more important.",
  },
  {
    title: "What tools and software are commonly used in HR?",
    category: "Trending",
    description:
      "HR uses tools like SAP HR, Workday, BambooHR, Zoho People, Excel, applicant tracking systems, payroll software, and performance management platforms to streamline hiring, documentation, employee data, and workforce planning.",
  },
  {
    title: "What job roles are available in the HR field?",
    category: "Design",
    description:
      "Common HR roles include HR Executive, Talent Acquisition Specialist, HR Generalist, HR Manager, Training and Development Specialist, Payroll Executive, HRBP, Employee Relations Executive, and Compensation & Benefits Analyst.",
  },
  {
    title: "What skills are important for building a career in HR?",
    category: "Design",
    description:
      "Key HR skills include communication, interviewing, negotiation, employee relations, conflict management, documentation, analytics, basic labor laws, empathy, and the ability to understand organizational behavior and workplace dynamics.",
  },
  {
    title: "What is Compensation and Benefits in HR?",
    category: "Design",
    description:
      "This function involves managing employee salaries, bonuses, incentives, insurance, perks, and rewards. HR ensures competitive and fair compensation packages that help attract and retain talent.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
